<template>
  <div class="mySetMeal">
    <a-tabs v-if="active" defaultActiveKey="2" @change="callback">
      <!--
      <a-tab-pane :tab="$tc('lang.payType.Balance_on_Account')" key="1">
        <balance></balance>
      </a-tab-pane>
      -->
      <a-tab-pane :tab="$tc('lang.payType.Pay_in_RMB')" key="2">
        <renm-pay></renm-pay>
      </a-tab-pane>
      <a-tab-pane :tab="$tc('lang.payType.Pay_in_USD')" key="3">
        <greback-pay></greback-pay>
      </a-tab-pane>
      <a-tab-pane
        v-if="type != '1'"
        :tab="$tc('lang.payType.Pay_in_Package')"
        key="4"
      >
        <packge></packge>
      </a-tab-pane>
    </a-tabs>
    <pay v-if="!active"></pay>
  </div>
</template>
<script>
import renmPay from './components/renmPay';
import grebackPay from './components/grebackPay';
//import balance from './components/balance';
import packge from './components/packge';
export default {
  data() {
    return {
      active: true,
      type: this.$route.query.type,
    };
  },
  components: {
    renmPay, //人民币支付
    grebackPay, // 美元支付
    //balance, // 余额支付
    packge, //套餐支付
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    init(value) {
      console.log('=====', value);
    },
  },
};
</script>
<style lang="less">
.mySetMeal {
  margin-top: 3%;
  text-align: left;
}
</style>
